<script>
    import BlogLanding from './BlogLanding.vue';
    import ListingPage from './listings/ListingPage.vue';
    import FindARep from './FindARep.vue';
    import ProductCrossPromo from './ProductCrossPromo.vue';
    import ProductListing from './ProductListing.vue';
    import CategoryPromos from './CategoryPromos.vue';
    import ProductVariations from './ProductVariations.vue';
    import AgProductVariations from './AgProductVariations.vue';
    import AgricultureBirdsEyeView from './AgricultureBirdsEyeView.vue';
    import CountryStateCounty from './forms/Country-State-County.vue';
    import TechnicalDrawings from './TechnicalDrawings.vue';
    import EditAccount from './account/EditAccount.vue';
    import CreateAccount from './account/CreateAccount.vue';
    import VideoThumbnail from './VideoThumbnail.vue';
    import { VSlickCarousel } from 'v-slick-carousel';
    import { VueFinalModal, ModalsContainer } from "vue-final-modal";
    import AccountLogin from './account/AccountLogin.vue'
    import KbMax  from './KbMax.vue';
    import ForgotPassword from './account/ForgotPassword.vue';
    import VideoButton from './VideoButton.vue'
    import InlineTemplateTester from './InlineTemplateTester.vue';
    import ProductRow from './ProductRow.vue'
    import UserSavedProjects from './account/UserSavedProjects.vue'
    
    //phase 1 "app" islands
    import AgHeroApp from './AgHeroApp.vue';
    import ImageVideoCarouselApp from './ImageVideoCarouselApp.vue';

    
    export default {
        name: 'AppWrapper',
        components: {
            VueFinalModal,
            ModalsContainer,
            VSlickCarousel,
            BlogLanding,
            ListingPage,
            FindARep,
            ProductCrossPromo,
            ProductListing,
            CategoryPromos,
            ProductVariations,
            AgricultureBirdsEyeView,
            CountryStateCounty,
            TechnicalDrawings,
            EditAccount,
            CreateAccount,
            VideoThumbnail,
            AccountLogin,
            KbMax,
            ForgotPassword,
            VideoButton,
            InlineTemplateTester,
            ProductRow,
            AgHeroApp,
            ImageVideoCarouselApp,
            AgProductVariations,
            UserSavedProjects
        }
        
    }
</script>